import React from 'react';
import PropTypes from 'prop-types';
import PreferencesSection from './PreferencesSection';
import Icon from 'SF/MaterialIcon';
import Switch from './PreferenceSwitch';
import css from './TextPreferences.scss';
import { getWord } from 'utils/tenant';
import { isEmptyString } from 'utils/text';
import OptOutInfo from './OptOutInfo';
import { pressedEnterOrSpace } from 'utils/accessibility';
import { isSupportedCellPhoneNumber } from 'utils/profile';
import TermsOfUseLink from 'common/TermsOfUseLink';
import PrivacyPolicyLink from 'common/PrivacyPolicyLink';

const TextPreferences = ({
    cellPhone, goToProfileDetails, setValue, supportedCountries, textNotificationEnabledForUser, isStaff
}) => {
    const getHeader = () => (
        <span>
            <Icon icon="stay_current_portrait" aria-hidden={true} />
            Text Notifications
            <Switch ariaLabel={"Send text notifications to my " + getWord('mobilePhone')}
                    checked={textNotificationEnabledForUser}
                    disabled={isEmptyString(cellPhone) || !isSupportedCellPhoneNumber(cellPhone, supportedCountries)}
                    onChange={(checked) => setValue({textNotificationEnabled: checked})} />
        </span>
    );

    const getCellPhone = () => {
        if (isEmptyString(cellPhone)) {
            return (
                <span className={css['empty-phone']}>
                    You can <a href="#" onClick={goToProfileDetails} onKeyDown={(e) => { if (pressedEnterOrSpace(e)) goToProfileDetails()}}>provide a valid {getWord('mobilePhone', true)} number</a> to receive text notifications.
                </span>
            );
        } else {
            return (
                <>
                    <label>Will send to my {getWord('mobilePhone')} Number:</label>
                    <span className={css['phone-label']}>{cellPhone}
                        <a className={css['profile-link']}
                           href="#"
                           onClick={goToProfileDetails}
                           onKeyDown={(e) => { if (pressedEnterOrSpace(e)) goToProfileDetails()} }>
                            Edit in Profile
                        </a>
                    </span>
                </>
            );
        }
    };


    return (
        <PreferencesSection className={css['text-options']}
                            headerText={getHeader()}>
            {getCellPhone()}
            <p>
                You may receive texts about {getWord('Starfish')} activity, such as appointment reminders and other updates, depending on your institution’s settings.
                Message and data rates may apply. Frequency varies. See <TermsOfUseLink /> and <PrivacyPolicyLink />.
            </p>
            <OptOutInfo cellPhone={cellPhone} 
                        textNotificationEnabledForUser={textNotificationEnabledForUser}
                        isStaff={isStaff} />
        </PreferencesSection>
    );
};

TextPreferences.propTypes = {
    cellPhone: PropTypes.string,
    goToProfileDetails: PropTypes.func.isRequired,
    setValue: PropTypes.func.isRequired,
    supportedCountries: PropTypes.string,
    textNotificationEnabledForUser: PropTypes.bool,
    isStaff: PropTypes.bool
};

export default TextPreferences;
